import { GET_STATUS_ERROR, GET_STATUS_LOAD, GET_STATUS_SUCCESS, SET_STATUS_ERROR, SET_STATUS_LOAD, SET_STATUS_RESET, SET_STATUS_SUCCESS } from "../../actions/types";

const innitialState = {
isUpdated:false
}
//set store status
export const setStoreStatusReducer = (state = innitialState,action:any)=>{

    switch (action.type) {
        case SET_STATUS_LOAD:
            return{
                isUpdated:false,
                 status:{}
                
            }
        case SET_STATUS_SUCCESS:
            return{
              isUpdated:true,
            status:action.data
            }
            
        case SET_STATUS_ERROR:
            return{
                error:action.error,
                isUpdated:false,
                 status:{}
                
            }
        case SET_STATUS_RESET:
            return {
                status:{},
                isUpdated:false
            }
    
        default:
           return state;
    }
}

//get store status
export const getStoreStatusReducer = (state = {loading:true},action:any)=>{

    switch (action.type) {
        case GET_STATUS_LOAD:
        return{
                loading:true,
                status:{}
            }
        case GET_STATUS_SUCCESS:
            return{
            loading:false,
             status:action.data
            }
            
        case GET_STATUS_ERROR:
            return{
                error:action.error,
                loading:false,
                status:{}
            }
    
        default:
           return state;
    }
}
